import { Select } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import React from "react";
const { Option } = Select;

interface NetwalaSelectProps {
  size?: "large" | "middle" | "small";
  height?: string;
  isStandardSelectedColor?: boolean; // Color for the selected option
  onChange?: (value: any) => void;
  options: Array<NetwalaSelectOptions>;
  value?: string | number | null | (string | number)[];
  showSearch?: boolean;
  disabled?: boolean;
  placeHolder?: string;
  mode?: "multiple" | "tags";
  maxTagCount?: number | "responsive";
  allowClear?: boolean;
  dropdownClassName?: string;
  dropdownStyle?: React.CSSProperties;
}

const NetwalaSelect: React.FC<NetwalaSelectProps> = ({
  size = "middle",
  height,
  onChange,
  options,
  value,
  isStandardSelectedColor = false,
  showSearch = false,
  disabled = false,
  placeHolder,
  mode,
  maxTagCount,
  allowClear = false,
  dropdownClassName,
  dropdownStyle,
}) => {
  const selectStyle: React.CSSProperties = {
    width: "100%",
    ...(height && { height }), // Apply height if provided
  };

  return (
    <Select
      disabled={disabled}
      className={`${
        isStandardSelectedColor === true ? "standard-select-control" : ""
      }`}
      value={value}
      style={selectStyle}
      size={size}
      onChange={onChange}
      showSearch={showSearch}
      optionFilterProp="label"
      placeholder={placeHolder ? placeHolder : ""}
      mode={mode}
      allowClear={allowClear}
      clearIcon={
        allowClear ? (
          <CloseOutlined style={{ fontSize: 12, color: "currentColor" }} />
        ) : undefined
      }
      dropdownClassName={dropdownClassName}
      dropdownStyle={dropdownStyle}
      {...(maxTagCount !== undefined && { maxTagCount })}
    >
      {options.map((option) => (
        <Option key={Math.random()} value={option.value} label={option.label}>
          {option.label}
        </Option>
      ))}
    </Select>
  );
};
export default NetwalaSelect;
